import {
  Box,
  CircularProgress,
  Grid,
  Divider,
  TextField,
  MenuItem,
  Typography,
} from "@mui/material";
import CameraAltRoundedIcon from "@mui/icons-material/CameraAltRounded";
import { cpfMask, cnpjMask, TextMaskCustom } from "../utils/masks";
import {
  FieldLabel,
  fieldStyle,
  profileAccent,
  profileAccentSoft,
} from "./profileFormStyles";

function getAccountInitial(formData) {
  const source = formData.firstName || formData.lastName || "Z";
  return source.trim().charAt(0).toUpperCase() || "Z";
}

const IdentitySection = ({
  formData,
  errors,
  handleChange,
  handleProfileImageChange,
  imageLoading = false,
  isPJ,
  profileImage,
}) => {
  const accountInitial = getAccountInitial(formData);

  return (
    <Grid container columnSpacing={2} rowSpacing={2.25}>
      <Grid item xs={12} md={3} lg={2}>
        <Box
          component="label"
          sx={{
            alignItems: "center",
            backgroundColor: profileImage ? "#dfe5ee" : "#eef2f7",
            backgroundImage: profileImage ? `url(${profileImage})` : "none",
            backgroundPosition: "center",
            backgroundSize: "cover",
            border: `4px solid ${profileImage ? "#ffffff" : profileAccentSoft}`,
            borderRadius: "999px",
            boxShadow: "0 10px 22px rgba(15, 23, 42, 0.14), 0 0 0 1px rgba(95, 72, 246, 0.16)",
            color: "#465568",
            cursor: "pointer",
            display: "flex",
            flexDirection: "column",
            gap: 0.75,
            height: { xs: 104, md: 128 },
            justifyContent: "center",
            mt: { xs: 0, md: 4 },
            mx: { xs: 0, md: "auto" },
            overflow: "hidden",
            position: "relative",
            width: { xs: 104, md: 128 },
            "&:hover .profile-photo-overlay": {
              opacity: 1,
            },
          }}
        >
          <Box
            component="input"
            type="file"
            accept="image/*"
            onChange={handleProfileImageChange}
            sx={{ display: "none" }}
          />

          {!profileImage && !imageLoading ? (
            <Typography
              sx={{
                fontSize: { xs: 42, md: 56 },
                fontWeight: 800,
                lineHeight: 1,
              }}
            >
              {accountInitial}
            </Typography>
          ) : null}

          {imageLoading ? (
            <CircularProgress size={28} sx={{ color: profileImage ? "#ffffff" : profileAccent }} />
          ) : null}

          <Box
            className="profile-photo-overlay"
            sx={{
              alignItems: "center",
              backgroundColor: profileImage
                ? "rgba(49, 35, 121, 0.82)"
                : "rgba(79, 59, 220, 0.9)",
              color: "#ffffff",
              display: "flex",
              flexDirection: "column",
              inset: 0,
              justifyContent: "center",
              opacity: imageLoading ? 1 : 0,
              position: "absolute",
              transition: "opacity 140ms ease",
            }}
          >
            <CameraAltRoundedIcon sx={{ fontSize: 22, mb: 0.75 }} />
            <Typography
              sx={{
                fontSize: { xs: 9, md: 11 },
                fontWeight: 800,
                lineHeight: 1.25,
                maxWidth: "78%",
                textAlign: "center",
              }}
            >
              EDITAR FOTO DA EMPRESA
            </Typography>
          </Box>
        </Box>
      </Grid>

      <Grid item xs={12} md={9} lg={10}>
        <Grid container columnSpacing={2} rowSpacing={2.25}>
          <Grid item xs={12}>
            <FieldLabel>Tipo *</FieldLabel>
            <TextField
              select
              fullWidth
              name="person_type"
              value={formData.person_type}
              onChange={handleChange}
              sx={fieldStyle}
            >
              <MenuItem value="PF">Pessoa Física (PF)</MenuItem>
              <MenuItem value="PJ">Pessoa Jurídica (PJ)</MenuItem>
            </TextField>
          </Grid>

          <Grid item xs={12}>
            <FieldLabel>{isPJ ? "Nome da conta *" : "Nome da conta *"}</FieldLabel>
            <TextField
              fullWidth
              required
              name="firstName"
              error={!!errors.firstName}
              helperText={errors.firstName}
              value={formData.firstName}
              onChange={handleChange}
              sx={fieldStyle}
            />
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12} md={6}>
        <FieldLabel>{isPJ ? "CNPJ *" : "CPF *"}</FieldLabel>
        <TextField
          fullWidth
          required
          name="cpf_cnpj"
          error={!!errors.cpf_cnpj}
          helperText={errors.cpf_cnpj}
          value={formData.cpf_cnpj}
          onChange={handleChange}
          sx={fieldStyle}
          InputProps={{
            inputComponent: TextMaskCustom,
            inputProps: { mask: isPJ ? cnpjMask : cpfMask },
          }}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <FieldLabel>{isPJ ? "Nome fantasia *" : "Sobrenome *"}</FieldLabel>
        <TextField
          fullWidth
          required
          name="lastName"
          error={!!errors.lastName}
          helperText={errors.lastName}
          value={formData.lastName}
          onChange={handleChange}
          sx={fieldStyle}
        />
      </Grid>

      <Grid item xs={12}>
        <Divider sx={{ borderColor: "#e2e8f0", mt: 1.25 }} />
      </Grid>
    </Grid>
  );
};

export default IdentitySection;
